import React from "react";
import {Button, Checkbox, Form, message, Modal, Select} from "antd";
import "./CodPaymentMethodSelectionForm.css";
import {useCodPaymentMethodSelection} from "../../../../../hooks/useCodPaymentMethodSelection";
import {useFormik} from "formik";
import * as Yup from "yup";
import {DocumentModal} from "../../../../documents/documentModal";
import {useStore} from "../../../../../hooks/useStore";
import {useHistory} from "react-router-dom";

export const CodPaymentMethodSelectionForm = ({
    paymentMethodsSelectionEnabledSubCompanies = [],
    recallState,
    recallFn = () => {}
}) => {
    const stores = useStore();
    const history = useHistory();
    const {
        canCodPaymentMethodSelectionSubcompanies,
        contractLoading,
        showContractsMissingFieldsModal,
        contractsMissingFields,
        resetContractsMissingFields,
        generateCoDPaymentContract
    } = useCodPaymentMethodSelection({
        initialCall: paymentMethodsSelectionEnabledSubCompanies?.length === 0,
        initialData: paymentMethodsSelectionEnabledSubCompanies,
        dependencies: []
    });

    const formik = useFormik({
        initialValues: {
            subCompanyId: canCodPaymentMethodSelectionSubcompanies?.[0]?._id,
            onlinePaymentMethod: true,
            codPaymentMethod: false,
            mealCardPaymentMethod: false,
            codContractUrl: "",
            showCodContractModal: false,
            codContractSigned: false,
            codContractId: ""
        },
        enableReinitialize: true,
        validationSchema: Yup.object().shape({
            subCompanyId: Yup.string().required("Şube seçilmedi")
        }),
        onSubmit: async values => {
            if (values.codPaymentMethod && !values.codContractSigned) {
                message.error("Sözleşme onaylanmamış");
                formik.setFieldError("codPaymentMethod", "Sözleşme onaylanmamış");
                return false;
            }

            const payload = {
                subCompanyId: values.subCompanyId,
                onlinePaymentMethod: values.onlinePaymentMethod,
                codPaymentMethod: values.codPaymentMethod,
                mealCardPaymentMethod: values.mealCardPaymentMethod
            };

            const resultOfRequest = await stores.companyStore.updateSubCompanyCodPaymentMethodsSelfSelection(
                payload
            );
            if (resultOfRequest?.success === false) {
                message.error(resultOfRequest?.message);
                return false;
            }

            recallFn();

            return true;
        }
    });

    const onChangeSubCompany = e => {
        formik.setValues({
            ...formik.initialValues,
            subCompanyId: e
        });
    };

    const onChangeCoDPaymentMethod = async e => {
        const isCoDPaymentMethodSelected = Boolean(e?.target?.checked);
        if (!isCoDPaymentMethodSelected) {
            formik.setFieldValue("codPaymentMethod", false);
            return;
        }

        const contract = await generateCoDPaymentContract({
            subCompanyId: formik.values.subCompanyId,
            createNewContract: true
        });

        if (contract?.success === false) {
            message.error(contract?.message);
            return;
        }

        formik.setValues({
            ...formik.values,
            codContractUrl: contract?.contractPath,
            codContractId: contract?.contractId,
            showCodContractModal: true
        });
    };

    const onCodContractApproved = async () => {
        try {
            const contractApproveResult = await stores.contractStore.changeApprovalStatus({
                contractId: formik.values.codContractId,
                isApproved: true
            });
            if (contractApproveResult?.success === false) {
                message.error(contractApproveResult?.message);
                formik.setValues({...formik.values, showCodContractModal: false});
                return false;
            } else {
                formik.setValues({
                    ...formik.values,
                    codPaymentMethod: true,
                    codContractSigned: true,
                    showCodContractModal: false
                });
            }
        } catch (error) {
            message.error("Sözleşme onaylanamadı");
            formik.setValues({...formik.values, showCodContractModal: false});
        }
        formik.setValues({
            ...formik.values,
            codPaymentMethod: true,
            codContractSigned: true,
            showCodContractModal: false
        });
    };

    return (
        <>
            <DocumentModal
                visibility={formik.values.showCodContractModal}
                onCancel={() => formik.setFieldValue("showCodContractModal", false)}
                documentUrl={formik.values.codContractUrl}
                title="Kapıda Ödeme Sözleşmesi"
                onApprove={onCodContractApproved}
                isNeedForApproval={true}
                description={
                    <p style={{fontSize: "20px", textAlign: "left", lineHeight: "1.8"}}>
                        Yukarda yazan hususlarda mutabık kaldığımı kabul eder, sözleşmenin bir
                        kopyasını bir hafta içerisinde ıslak imzalı olarak Vigo Merkez Ofise
                        göndereceğimi teyit ederim.
                    </p>
                }
            />
            <Form layout="horizontal" style={{textAlign: "left"}}>
                <div
                    style={{
                        fontSize: "26px",
                        fontWeight: "bold",
                        marginBottom: "0px",
                        textAlign: "center"
                    }}
                >
                    Ödeme Yöntemi Seçim Formu
                </div>
                {/* {canCodPaymentMethodSelectionSubcompanies?.length > 1 && (
                    <Form.Item
                        validateStatus={
                            formik.touched.subCompanyId && formik.errors.subCompanyId ? "error" : ""
                        }
                        help={
                            formik.touched.subCompanyId && formik.errors.subCompanyId
                                ? formik.errors.subCompanyId
                                : null
                        }
                    >
                        <div style={{fontSize: "20px", fontWeight: "bold", marginBottom: "0px"}}>
                            Şube Seçiniz
                        </div>
                        <Select
                            name="subCompanyId"
                            onChange={onChangeSubCompany}
                            value={formik.values.subCompanyId}
                            loading={subCompaniesResultsLoading}
                        >
                            {canCodPaymentMethodSelectionSubcompanies?.map(subCompany => (
                                <Select.Option key={subCompany._id} value={subCompany._id}>
                                    {subCompany.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                )} */}
                <div style={{fontSize: "20px", fontWeight: "bold", marginBottom: "8px"}}>
                    Ödeme Yöntemi Seçiniz
                </div>
                <Form.Item name="paymentMethod" style={{marginBottom: "8px"}}>
                    <Checkbox
                        checked={formik.values.onlinePaymentMethod}
                        disabled={contractLoading}
                        className="luckyCheckbox"
                    >
                        Sadece Online
                    </Checkbox>
                </Form.Item>
                <Form.Item name="paymentMethod" style={{marginBottom: "8px"}}>
                    <Checkbox
                        className="luckyCheckbox"
                        checked={formik.values.codPaymentMethod}
                        onChange={onChangeCoDPaymentMethod}
                        disabled={contractLoading}
                    >
                        {contractLoading ? <b>Sözleşme Oluşturuluyor...</b> : ""} Kapıda Ödeme
                        (Kredi Kartı veya Nakit)
                    </Checkbox>
                </Form.Item>
                <Form.Item name="paymentMethod" style={{marginBottom: "0px"}}>
                    <Checkbox
                        checked={formik.values.mealCardPaymentMethod}
                        disabled={true}
                        className="luckyCheckbox"
                    >
                        Yemek Kartı (Online/Kapıda) - Yakında Gelecek
                    </Checkbox>
                </Form.Item>
                <p style={{fontSize: "16px", marginTop: "16px", lineHeight: "1.8"}}>
                    VigoPOS ile Vigo kuryelerinin sizin adınıza kapıda ödeme alabilmesi için,
                    <br />
                    <b>Kapıda Ödeme (Kredi Kartı veya Nakit)</b> seçeneğini seçmeli <br />
                    ve çıkan <b>dijital sözleşmeyi</b> okuyup onaylamalısınız.
                </p>

                <Form.Item>
                    <div style={{width: "100%", display: "flex", justifyContent: "space-between"}}>
                        <Button
                            type="primary"
                            size="large"
                            htmlType="submit"
                            onClick={formik.handleSubmit}
                            loading={formik.isSubmitting}
                            disabled={contractLoading}
                        >
                            {contractLoading ? "Sözleşme Oluşturuluyor..." : "Seçimi Onayla"}
                        </Button>
                        <Button
                            size="large"
                            htmlType="submit"
                            onClick={() => history.push("/musteri/hesabim")}
                            disabled={contractLoading}
                        >
                            {"Hesap Bilgilerini Düzenle"}
                        </Button>
                    </div>
                </Form.Item>
            </Form>
            <Modal
                visible={showContractsMissingFieldsModal}
                title="Sözleşme Oluşturulamadı"
                onCancel={resetContractsMissingFields}
                cancelText="İptal"
                okText="Hesap Bilgilerini Düzenle"
                onOk={() => {
                    window.open("/musteri/hesabim", "_blank");
                }}
            >
                <p style={{fontSize: "16px", marginTop: "16px", lineHeight: "1.8"}}>
                    Lütfen hesap bilgilerinizi düzenleyiniz.
                    <br />
                    Eksik alanlar:{" "}
                    <ul>
                        {contractsMissingFields?.map(field => (
                            <li key={field}>{field}</li>
                        ))}
                    </ul>
                </p>
            </Modal>
        </>
    );
};
